import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ObjectifPro } from 'src/app/shared/models/objectifPro';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class ObjectifProService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllObjectifPro(): Observable<ObjectifPro[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.objectifProUrl}/all`,
			'getAllObjectifPro'
		);
	}

	importObjectifPro(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'objectifPro.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.objectifProUrl}/import`,
			`importObjectifPro`,
			formData
		);
	}

	getObjectifProById(id: number): Observable<ObjectifPro> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.objectifProUrl}/get/${id}`,
			'getObjectifProById'
		);
	}

	updateObjectifPro(objectifPro: ObjectifPro): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.objectifProUrl}/update/${objectifPro.id}`,
			'updateObjectifPro',
			objectifPro
		);
	}

	addObjectifPro(objectifPro: ObjectifPro): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.objectifProUrl}/add`,
			'addObjectifPro',
			objectifPro
		);
	}

	deleteObjectifPro(objectifProId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.objectifProUrl}/delete/${objectifProId}`,
			`deleteObjectifPro`
		);
	}
}
